export default function ReloadAPI() {
  const reloadPage = () => {
    location.reload();
  };

  return {
    reloadPage,
  };
}
